import { styled } from '@mui/material/styles';
import React from 'react';

const Circle = styled('div')(({ theme }) => ({
  width: '20px',
  height: '20px',
  borderRadius: '50%',
  backgroundColor: '#031839',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.common.white,
  fontSize: '14px',
  marginRight: theme.spacing(2),
  marginTop: theme.spacing(0.5),
}));

export type CircleWithNumberProps = {
  number: number;
};

const CircleWithNumber: React.FC<CircleWithNumberProps> = ({ number }) => {
  return <Circle>{number}</Circle>;
};

export default CircleWithNumber;
